import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  pageState: {
    page: 0,
    pageSize: 10,
    total: 0,
    totalRecords: 0,
  },
  selectedVideos: [],
  searchState: {
    page: 0,
    pageSize: 10,
    total: 0,
    totalRecords: 0,
    isRecordSearched: false,
  },
  deletedVideosList: [],
  searchedVideos: [],
  loading: false,
};

export const StorageManagementReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_DELETED_VIDEOS:
      if (payload.isVideoRestored) {
        return {
          ...state,
          deletedVideosList: payload.data.eventMedia,
          pageState: {
            page: payload.page,
            total: payload.data.totalPages,
            totalRecords: payload.data.total,
          },
        };
      } else {
        return {
          ...state,
          deletedVideosList: [
            ...state.deletedVideosList,
            ...payload.data.eventMedia,
          ],
          pageState: {
            page: payload.page,
            total: payload.data.totalPages,
            totalRecords: payload.data.total,
          },
        };
      }

    case ActionTypes.DELETE_VIDEO_FROM_STORAGE_MANAGEMENT:
      let videos = [...state.deletedVideosList];
      const filteredArray = videos.filter((video) => {
        return !payload.videoIds.includes(video.id);
      });
      return state;

    case ActionTypes.SELECT_UNSELECT_VIDEO_ON_STORAGE_MANAGEMENT:
      let tempArr = [...state.selectedVideos];
      if (payload.checked) {
        if (tempArr.length === state.deletedVideosList.length) {
          tempArr = [payload.item];
        } else {
          tempArr.push(payload.item);
        }
      } else {
        tempArr = tempArr.filter((videos) => videos.id !== payload.item.id);
      }
      return {
        ...state,
        selectedVideos: tempArr,
      };

    case ActionTypes.UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT:
      return {
        ...state,
        selectedVideos: [],
      };

    case ActionTypes.SEARCH_VIDEOS:
      if (payload.isVideoRestored) {
        return {
          ...state,
          searchedVideos: payload.data.eventMedia,
          searchState: {
            page: payload.page,
            total: payload.data.totalPages,
            totalRecords: payload.data.total,
            isRecordSearched: true,
          },
        };
      } else {
        return {
          ...state,
          searchedVideos: [...state.searchedVideos, ...payload.data.eventMedia],
          searchState: {
            page: payload.page,
            total: payload.data.totalPages,
            totalRecords: payload.data.total,
            isRecordSearched: true,
          },
        };
      }

    case ActionTypes.SET_UNSEARCH_RECORD:
      return {
        ...state,
        searchState: {
          page: 0,
          pageSize: 10,
          total: 0,
          totalRecords: 0,
          isRecordSearched: false,
        },
      };

    case ActionTypes.SET_STORAGE_MANAGEMENT_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case ActionTypes.REMOVE_DELETED_VIDEOS:
      return {
        ...state,
        deletedVideosList: [],
      };

    default:
      return state;
  }
};
